
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexF5p6_45Kd3OL4HUxv_45GzAJIkYY69t4Vc56rP7DFeypWX4Meta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/index.vue?macro=true";
import { default as logineymFuGjvM8OoDvN8sTQyDosS_45n4IWPhtb0NEdhckON0Meta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/login.vue?macro=true";
import { default as usersCn69s9e3gbZedRLY6e_fSFyZWl_45651rKmJVRbcGY0PAMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/users.vue?macro=true";
import { default as persons7DrJ1SAD77fq5p3_45Ed7oRlC2yjasF05s9_45SXjx1kiNUMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/persons.vue?macro=true";
import { default as summarywBtkej1i0HLgGFvcsvZtl_ZwYPZ9GVHqRRE_Hh_452ungMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/summary.vue?macro=true";
import { default as products2blsaVMcbkJuEM_45OFptvkZGwcYzZLrApr_byXkD5IgIMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/products.vue?macro=true";
import { default as settingsEcyEIWeaHKijS2nOQH0Cnx39_45k9FRtC0lP_ShAjPbJQMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/settings.vue?macro=true";
import { default as locationseY7uMT60zRR4k2mIhSKmlmK2iORQONtA2OBmj1GYozIMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/locations.vue?macro=true";
import { default as ssoCallbackqD3JzKWYBWHCLeVLOWcuPjh8w_jIloJJUsFrF8aap0MMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/ssoCallback.vue?macro=true";
import { default as transportereKx6zxxaaZBDddsVnjL2eN9Gp2vav4oNlclAmmeIVT4Meta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/transporter.vue?macro=true";
import { default as organizations_lvMJhn9k1xQZFs5gtekhWTEwMNbv76fuxeND_453EHtsMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/organizations.vue?macro=true";
import { default as createPasswordS6FmAjMeudsPtz0U7Q0C_45rst7hTc_45DMSKhyCyjOnyjoMeta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/createPassword.vue?macro=true";
import { default as requestPasswordResetrazJcBMa_g_45jdbuNJG_A2cEe0KeANVCtWXG0yAhWER0Meta } from "/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/requestPasswordReset.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/login.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/users.vue")
  },
  {
    name: "persons",
    path: "/persons",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/persons.vue")
  },
  {
    name: "summary",
    path: "/summary",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/summary.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/products.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/settings.vue")
  },
  {
    name: "locations",
    path: "/locations",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/locations.vue")
  },
  {
    name: "ssoCallback",
    path: "/ssoCallback",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/ssoCallback.vue")
  },
  {
    name: "transporter",
    path: "/transporter",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/transporter.vue")
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/organizations.vue")
  },
  {
    name: "createPassword",
    path: "/createPassword",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/createPassword.vue")
  },
  {
    name: "requestPasswordReset",
    path: "/requestPasswordReset",
    component: () => import("/home/runner/work/Keurt.Frontend/Keurt.Frontend/pages/requestPasswordReset.vue")
  }
]